import MastersDataModel from '../Apis/MastersData.js'
import Controller from './Controller.js';

export default class MastersDataController extends Controller {

    constructor() {
        super(new MastersDataModel());
    }


}